<template>
  <div
    class="kpi-stat-card"
    :class="{
      'kpi-stat-card--highlight': highlight,
      'kpi-stat-card--alert': variant === 'alert',
      'kpi-stat-card--clickable': isClickable
    }"
    :role="isClickable ? 'button' : undefined"
    :tabindex="isClickable ? 0 : undefined"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <span
      v-if="isClickable"
      class="kpi-stat-card__arrow"
      aria-hidden="true"
    >
      →
    </span>
    <div class="kpi-stat-card__label">
      {{ label }}
    </div>
    <div class="kpi-stat-card__value">
      {{ value }}
    </div>
    <div
      v-if="sublabel"
      class="kpi-stat-card__sublabel"
    >
      {{ sublabel }}
    </div>
    <div
      v-if="variant === 'alert' && threshold"
      class="kpi-stat-card__threshold"
    >
      Limiar: {{ threshold }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseKpiStatCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    sublabel: {
      type: String,
      required: false,
      default: ''
    },
    highlight: {
      type: Boolean,
      required: false,
      default: false
    },
    variant: {
      type: String,
      required: false,
      default: 'default',
      validator: (value) => ['default', 'alert'].includes(value)
    },
    threshold: {
      type: String,
      required: false,
      default: ''
    },
    detail: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    isClickable() {
      return Boolean(this.detail)
    }
  },
  created() {
    if (process.env.NODE_ENV !== 'production' && this.variant === 'alert' && !this.detail) {
      // eslint-disable-next-line no-console
      console.warn(
        `BaseKpiStatCard: card alert "${this.label}" sem "detail" — todo card alert deveria ter uma rota de resolução.`
      )
    }
  },
  methods: {
    handleClick() {
      if (this.detail) {
        this.$emit('row-detail', { detail: this.detail })
      }
    }
  }
}
</script>

<style lang="scss">
.kpi-stat-card {
  background: var(--ds-color-black-005);
  border: 1px solid var(--ds-color-black-010);
  border-radius: 8px;
  padding: 16px;
  position: relative;

  &--clickable {
    cursor: pointer;

    &:hover {
      box-shadow: 0 1px 6px var(--ds-color-black-025);
    }

    &:focus-visible {
      outline: 2px solid var(--v-primary-base);
      outline-offset: 2px;
    }
  }

  &__arrow {
    position: absolute;
    top: 14px;
    right: 14px;
    color: var(--ds-color-black-040);
  }

  &--clickable &__label {
    padding-right: 20px;
  }

  &--highlight {
    background: var(--v-primaryFaint-base);
    border-color: var(--v-primary-lighten4);
  }

  &--alert {
    border-color: var(--v-warning-base);

    .kpi-stat-card__value {
      color: var(--v-warning-base);
    }
  }

  &__label {
    font-size: 0.875rem;
    color: var(--ds-color-black-055);
    font-weight: 500;
    margin-bottom: 6px;
  }

  &__value {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
    margin-bottom: 4px;
    color: var(--v-textPrimary-base);
  }

  &__sublabel {
    font-size: 0.8rem;
    color: var(--ds-color-black-040);
  }

  &__threshold {
    font-size: 0.75rem;
    color: var(--v-warning-base);
    margin-top: 2px;
  }
}
</style>
